import {
  GitCommit,
  Activity,
  GitPullRequest,
  Users,
  BarChart3,
  GitBranch,
  FileText,
  History,
} from 'lucide-react';

export const REPOSITORY_DETAIL_TABS = [
  { id: 'overview', label: 'Overview', icon: BarChart3 },
  { id: 'metrics', label: 'Metrics', icon: BarChart3 },
  { id: 'documents', label: 'Documents', icon: FileText },
  { id: 'branches', label: 'Branches', icon: GitBranch },
  { id: 'commits', label: 'Commits', icon: GitCommit },
  { id: 'history', label: 'History', icon: History },
  { id: 'activity', label: 'Activity', icon: Activity },
  { id: 'pull-requests', label: 'Pull requests', icon: GitPullRequest },
  { id: 'contributors', label: 'Contributors', icon: Users },
];

const TAB_FLAGS = {
  overview: null,
  metrics: null,
  documents: 'ui.repositoryDetail.documentsTab',
  commits: 'ui.repositoryDetail.commitsTab',
  history: 'ui.repositoryDetail.historyTab',
  branches: 'ui.repositoryDetail.branchesTab',
  activity: 'ui.repositoryDetail.activityTab',
  'pull-requests': 'ui.repositoryDetail.pullRequestsTab',
  contributors: 'ui.repositoryDetail.contributorsTab',
};

export function getRepositoryDetailVisibleTabs(flags) {
  return REPOSITORY_DETAIL_TABS.filter(
    (t) => t.id === 'overview' || t.id === 'metrics' || flags[TAB_FLAGS[t.id]] === true
  );
}
